<template lang='pug'>
//- 臨床計畫提案、
div(:class='$style[`cc-popbox-business-request`]')
  .popbox-close
    button.popbox-close-btn(
      aria-label='關閉'
      tabindex='0'
      @click='handleClosePopBox')

  div(:class='$style[`cc-content-new`]')
    div(:class='$style[`cc-content-title`]')
      span.font-bold(:class='$style[`cc-banner-main-title`]')
        span.no-wrap {{ purpose === 'trail' ? '試驗計畫合作提案' : '商務訂閱專案詢價' }}
      div(:class='$style[`cc-content-title-tips`]') {{ purpose === 'trail' ? '感謝您的合作提案，我們將於 3 個工作日內回覆您。' : '我們將於 3 個工作日內回覆您，提供詳細專案說明。' }}

    Inputer(
      title='貴單位或組織名稱'
      v-model.trim='formConfig.unitValue'
      :class='$style[`cc-content-new-input`]'
      :resetButton='false'
      :placeholder='`貴單位名稱`'
      :errorValue='formVerify.unitError'
      @clearErrorMsg="(value) => {this.formVerify.unitError = value[0];}")

    Inputer(
      title='貴單位聯絡信箱'
      v-model.trim='formConfig.emailValue'
      :class='$style[`cc-content-new-input`]'
      :resetButton='false'
      :placeholder='`貴單位聯絡信箱`'
      :errorRegex='formVerify.emailRegexError'
      :errorRegexInfo='formVerify.emailErrorLog'
      :errorValue='formVerify.emailError'
      @clearErrorMsg="(value) => {this.formVerify.emailError = value[0]; this.formVerify.emailRegexError = value[1]; this.showErrorMsg = false;}")

    Inputer(
      title='貴單位網站或介紹'
      v-model.trim='formConfig.websiteValue'
      :class='$style[`cc-content-new-input`]'
      :resetButton='false'
      :placeholder='`貴單位網站、介紹網址`'
      :errorValue='formVerify.websiteError'
      @clearErrorMsg="(value) => {this.formVerify.websiteError = value[0];}")

    TextAreaer(
      v-model='formConfig.opinionValue'
      :title='purpose === `trail` ? `提案內容描述或說明` : `想詢問的問題`'
      :autoSize='true'
      :class='$style[`cc-input-textarea`]'
      :resetButton='false'
      :placeholder='purpose === `trail` ? `提案內容描述或說明` : `想詢問的問題`'
      :errorValue='formVerify.opinionError'
      @clearErrorMsg='(value) => {this.formVerify.opinionError = value[0];}')

    button(
      title='送出'
      tabindex='0'
      aria-label='送出'
      :class='$style[`cc-content-new-send`]'
      @click='handleSendRequest')
      IconLoading(v-if='showLoading' :size='18' :color='`#fff`')
      span {{ showLoading ? `` : `送出`}}

</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import Inputer from '../common/Input';
import TextAreaer from '../common/TextArea';
import IconLoading from '../../icon/Loading';

import {
  postBusinessRequestMail,
} from '../../../js/restapi';

export default {
  components: {
    Inputer,
    TextAreaer,
    IconLoading,
  },

  props: {
    purpose: null,
  },

  data() {
    return {
      showLoading: false,
      formConfig: {
        unitValue: '',
        websiteValue: '',
        emailValue: '',
        opinionValue: '',
      },
      formVerify: {
        unitError: false,
        websiteError: false,

        emailRegexError: false,
        emailErrorLog: '',
        emailError: false,

        opinionError: false,
      },
      verifyAllPass: true,
    };
  },

  methods: {
    ...mapMutations({
      changePopBoxStatus: 'global/POPBOX_STATUS',
      changePopBusinessRequest: 'global/POPBUSINESS_REQUEST',
    }),

    handleClosePopBox() {
      this.changePopBusinessRequest({
        active: false,
        detail: {},
      });
    },

    handleFormsCheckToPass() {
      this.verifyAllPass = this.$options.data().verifyAllPass;
      const emailPattern = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

      if (this.formConfig.emailValue) {
        // 信箱格式有誤
        if (!this.formConfig.emailValue.match(emailPattern)) {
          this.formVerify.emailRegexError = true;
          this.formVerify.emailError = true;
          this.formVerify.emailErrorLog = '格式錯誤(範例: mail@cancell.ai)';
          this.verifyAllPass = false;
        }
      } else {
        this.formVerify.emailError = true;
        this.verifyAllPass = false;
      }

      if (!this.formConfig.unitValue) {
        this.formVerify.unitError = true;
        this.verifyAllPass = false;
      }

      if (!this.formConfig.websiteValue) {
        this.formVerify.websiteError = true;
        this.verifyAllPass = false;
      }

      if (!this.formConfig.opinionValue) {
        this.formVerify.opinionError = true;
        this.verifyAllPass = false;
      }
    },

    handleStartProcess() {
      if (!this.verifyAllPass) { return; }

      this.showLoading = true;

      postBusinessRequestMail('', {
        purpose: this.purpose,
        unit: this.formConfig.unitValue,
        email: this.formConfig.emailValue,
        website: this.formConfig.websiteValue,
        opinion: this.formConfig.opinionValue,
      }).then(() => {
        this.showLoading = false;

        this.handleClosePopBox();
        this.changePopBoxStatus({
          active: true,
          include: 'sendConfirm',
        });

        setTimeout(() => {
          this.changePopBoxStatus({
            active: false,
            include: '',
          });
        }, this.POP_DURATION);
      }).catch(() => {
        this.showLoading = false;
      });
    },

    async handleSendRequest() {
      await this.handleFormsCheckToPass();
      await this.handleStartProcess();
    },
  },

  // eslint-disable-next-line vue/order-in-components
  computed: {
    ...mapGetters({
      // authJwtToken: 'user/exportUserJwtToken',
      loginHashCode: 'user/exportUserHashCode',
      loginStatus: 'user/exportLoginStatus',
      loginProfile: 'user/exportUserProfile',
    }),
  },
};

</script>

<style module lang='scss'>
  @import '../../../sass/component/page/popbox/popBusinessRequest.scss';
</style>
